
export default {
  data() {
    return {
      id: null,
      loading: false,
      data: {},
      visible: false,
    }
  },
  methods: {

    init(data) {
      this.visible = true
      this.data = data
    },

    query(id) {
      this.loading = true
      this.$request.batteryAlarm(id).then( resp => {
        this.loading = false
        if(resp.code == 0){
          
          this.data = this.$utils.conv(resp.data , {'repostStartTime':'datetime','repostEndTimeText':'datetime','alarmLevel':'batteryAlarmLevel'})

        }else{
          this.$Message.error({ content: resp.msg })
        }
      })
    },
  },
  render(){
    const { loading , data } = this
    const title = '告警信息'
    return (
      <sl-side-panel destroyOnClose={true} v-model={this.visible} mask-closable={false} title={title} loading={loading}>
       <sl-detail-list col={1} label-width="100px" label-align="right" style="padding:12px;">
          <sl-detail-list-item title="告警时间">{data.repostStartTimeText}</sl-detail-list-item>
          <sl-detail-list-item title="释放时间">{data.repostEndTimeText}</sl-detail-list-item>
          <sl-detail-list-item title="告警等级">{data.alarmLevelText}</sl-detail-list-item>
          <sl-detail-list-item title="告警类型">{data.alarmDesc}</sl-detail-list-item>
          <sl-detail-list-item title="车辆编号">{data.carNo}</sl-detail-list-item>
          <sl-detail-list-item title="车架号">{data.frameNo}</sl-detail-list-item>
          <sl-detail-list-item title="设备编号">{data.imei}</sl-detail-list-item>
          <sl-detail-list-item title="所属企业">{data.companyName}</sl-detail-list-item>
          <sl-detail-list-item title="快递员">{data.courierName}</sl-detail-list-item>
          <sl-detail-list-item title="手机号">{data.courierPhone}</sl-detail-list-item>
        </sl-detail-list>
      </sl-side-panel>
    )
  }
}